// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.pane_fxxai {
  position : absolute;
  bottom : var( --size-padLarge, 24px);
  left : var( --size-padLarge, 24px);
  gap : var( --size-padLarge, 24px);
  padding : var( --size-padLarge, 24px);

  display : inline-grid;
  grid-template-areas: 
    "title title"
    "help help"
    "cancel okay";
  grid-template-columns: 160px 160px;
}

.title_VJ5lY {
  grid-area: title;
}

.help_YFBEW { 
  grid-area: help;
  --textIconAlign : 'start';
}

.cancel_FVjr_ {
  grid-area: cancel;
}

.okay_y9Hxn {
  grid-area: okay;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/imagine/map/OkayCancelView.css"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,kCAAkC;EAClC,iCAAiC;EACjC,qCAAqC;;EAErC,qBAAqB;EACrB;;;iBAGe;EACf,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["\n.pane {\n  position : absolute;\n  bottom : var( --size-padLarge, 24px);\n  left : var( --size-padLarge, 24px);\n  gap : var( --size-padLarge, 24px);\n  padding : var( --size-padLarge, 24px);\n\n  display : inline-grid;\n  grid-template-areas: \n    \"title title\"\n    \"help help\"\n    \"cancel okay\";\n  grid-template-columns: 160px 160px;\n}\n\n.title {\n  grid-area: title;\n}\n\n.help { \n  grid-area: help;\n  --textIconAlign : 'start';\n}\n\n.cancel {\n  grid-area: cancel;\n}\n\n.okay {\n  grid-area: okay;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pane": `pane_fxxai`,
	"title": `title_VJ5lY`,
	"help": `help_YFBEW`,
	"cancel": `cancel_FVjr_`,
	"okay": `okay_y9Hxn`
};
export default ___CSS_LOADER_EXPORT___;
